
import patterns from '../api/patterns'

export const state = {
  patterns: [],
  pattern: ''
}

export const getters = {
  patterns: state => state.patterns,
  pattern: state => state.pattern
}

export const mutations = {
  ADD_PATTERN (state, data) {
    state.patterns.push(data)
  },
  SET_PATTERNS (state, data) {
    state.patterns = data
  },
  SHOW_PATTERN (state, data) {
    state.pattern = data
  }
}

export const actions = {
  GET_PATTERNS ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      patterns.get(data).then(response => {
        commit('SET_PATTERNS', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  CREATE_PATTERNS ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      patterns.create(data).then(response => {
        commit('ADD_PATTERN', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  SHOW_PATTERN ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      patterns.show(id).then(response => {
        commit('SHOW_PATTERN', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  EDIT_PATTERN ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      patterns.update(data.data, data.id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  REMOVE_PATTERN ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      patterns.delete(id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/patterns.js